export const promotionTypeEnum = {
    ANNUAL: 'annual',
    SEASONAL: 'seasonal',
    ALL: 'all'
}

export const packageTypeEnum = {
    ANNUAL: 'annual',
    SEASONAL: 'seasonal',
}

export const discountType = {
    PERCENTAGE: 'percentage',
    AMOUNT: 'amount'
}

export const packageTypeId = {
    KOSOVA: 4,
    BALLKANI: 5,
    EVROPA: 6,
    PERSONALE: 7
}